import { TwoFactorSmsPhonenumberChange } from "@/components/Portal/UserAccount/Security/Change/TwoFactorSmsPhonenumberChange";
import { TwoFactorChangeTitle } from "@/components/Portal/UserAccount/Security/TwoFactorChangeTitle";

export const TwoFactorChangeSmsView = () => {
  return (
    <div className="flex max-w-[560px] flex-col gap-6">
      <TwoFactorChangeTitle />
      <TwoFactorSmsPhonenumberChange />
    </div>
  );
};
